import type { TableColumnConfig } from '@peanuds/ui';
import type { TransactionTableRow } from '@peanuds/shared';

type AmountCellProps = {
  formatter?: (row: TransactionTableRow) => string;
};

export const controlSpendingColumns: readonly TableColumnConfig[] = [
  {
    key: 'name',
    field: 'senderName',
    header: 'controlSpending.table.name',
    style: 'width: 16rem',
    bodySlot: 'name',
  },
  {
    key: 'date',
    field: 'dateAndTime',
    header: 'controlSpending.table.date',
    style: 'width: 16rem',
    sortable: true,
    headerClass: 'cs-table__date-header',
    bodySlot: 'date',
  },
  {
    key: 'status',
    field: 'status',
    header: 'controlSpending.table.status',
    style: 'width: 10rem',
    bodySlot: 'status',
  },
  {
    key: 'amount',
    header: 'controlSpending.table.amount',
    style: 'width: 10rem',
    headerClass: 'cs-table__amount-header',
    bodySlot: 'amount',
  },
] as const;

export const controlSpendingReferenceColumn: TableColumnConfig = {
  key: 'reference',
  field: 'reference',
  header: 'controlSpending.table.reference',
  style: 'width: 6rem; max-width: 6rem',
  headerStyle: 'width: 6rem; max-width: 6rem',
  headerClass: 'cs-table__reference-header',
  class: 'cs-table__reference-cell',
  bodySlot: 'reference',
  cellProps: {
    display: 'preview-popover',
    source: 'details',
  },
};

export const getControlSpendingColumns = (
  hasReferenceDetails: boolean,
  amountCellProps?: AmountCellProps,
): readonly TableColumnConfig[] => {
  const columns = controlSpendingColumns.map((column) => {
    if (column.key !== 'amount') return column;

    return {
      ...column,
      cellProps: amountCellProps,
    };
  });

  if (!hasReferenceDetails) {
    return columns;
  }

  return [...columns.slice(0, 2), controlSpendingReferenceColumn, ...columns.slice(2)];
};
